// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__1CQWN","gfeWrapper":"CalendarEvent_gfeWrapper__2VTC_"};